/*
*
* File JS componente Archive Filters
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './archive-filters.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const archiveFilters = () => {

    let archiveFilterBlock = document.querySelector('.archive-filters');
    let textInputFilter = document.querySelector('.archive-filters .search-text input');
    let btnFilters = document.querySelector('.archive-filters__submit');
    let allSelectFilters = document.querySelectorAll('.archive-filters__select');

    if (!archiveFilterBlock) return;
    
    btnFilters.addEventListener('click', (evt) => 
    {
        evt.preventDefault();

        let destUrl = '';
        let yearUrl = '';
        let categoryUrl = '';
        let channelUrl = '';
        let textUrl = '';

        allSelectFilters.forEach(el => {
            
            if (el.value == '-1') return;

            switch (el.name) {
                case 'year':
                    yearUrl += `/${el.value}`;
                    break;
                case 'category':
                    categoryUrl += `/${el.value}`;
                    break;
                case 'channel':
                    channelUrl += `?channel=${el.value}`;
                    break;
            }
        });

        if (textInputFilter)
        {
            if (textInputFilter.value !== '')
            {
                if (channelUrl !== '')
                {
                    textUrl += '&';
                }
                else
                {
                    textUrl += '?';
                }
    
                textUrl += `text=${textInputFilter.value}`;
            }
        }

        destUrl = categoryUrl + yearUrl + channelUrl + textUrl;

        if (destUrl !== '') 
        {
            window.location = immediaData.path_page_filters  + destUrl;
        }
        else
        {
            window.location = immediaData.path_page_filters;
        }
        return false;
    });
}

export default archiveFilters;

//--------------------------------------------------------------------//